import { formRedirectRoute } from 'src/helpers/navigation';

export const content = {
  trialEnded: (date: string) => `Your free 60 day trial ended on ${date}.`,
  upgradeLink: {
    text: 'Upgrade',
    href: formRedirectRoute('account/products'),
  },
  guideLink: {
    text: 'guide',
    href: formRedirectRoute('guide'),
  },
  upgradeText: {
    noDiscount: 'now to get the most out of your email program.',
    withDiscount:
      'before your trial ends to take advantage of a limited time discount on select plans.',
  },
  trialEnding: (endDate: string) => ({
    both: `Your free trial ends on ${endDate}.`,
    ei: `Your free trial of Email API ends on ${endDate}.`,
    mc: `Your free trial of Marketing Campaigns ends on ${endDate}.`,
  }),
  freeEnding: (endDate: string) => ({
    both: `Your free use of SendGrid ends on ${endDate}.`,
    ei: `Your free use of Email API ends on ${endDate}.`,
    mc: `Your free use of Marketing Campaigns ends on ${endDate}.`,
  }),
};
